<template>
  <div class="text-center">
    <v-dialog persistent v-model="openCreateForm" width="700" scrollable>
      <v-card>
        <loader v-if="showLoader"></loader>
        <v-card-title class="headline grey lighten-2">{{ modalType }} Marketing Agency</v-card-title>

        <v-card-text class="addbox">
          <div>
            <v-form ref="createForm" v-model="valid" lazy-validation class="input-container">
              <v-row>
                <v-col cols="12" md="4" sm="6">
                  <v-text-field
                    v-model="formData.contactPerson"
                    :rules="contactPersonRules"
                    label="Contact person"
                    required
                    name="contactPerson"
                    id="contactPerson"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <v-text-field
                    v-model="formData.contactNumber"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                    :rules="contactNumberRules"
                    label="Contact Number"
                    name="contactNumber"
                    id="contactNumber"
                    maxlength="10"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <v-text-field
                    v-model="formData.nameOfCompany"
                    label="Name Of Company"
                    name="nameOfCompany"
                    id="nameOfCompany"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" sm="6">
                  <v-text-field
                    v-model="formData.contactEmail"
                    label="Enter Email"
                    name="userEmail"
                    id="userEmail"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" sm="6">
                  <v-text-field
                    v-model="formData.allocateReferralCode"
                    :loading="showLoader"
                    label="Allocate Referral Code"
                    :readonly="true"
                    :disabled="true"
                    name="allocateReferralCodeRules"
                    id="allocateReferralCodeRules"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12" sm="6">
                  <v-textarea
                    v-model="formData.typeOfAgreement"
                    outlined
                    label="Type Of Agreement"
                    name="typeOfAgreement"
                    id="typeOfAgreement"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="12" sm="6">
                  <div class="text-left">Attach File</div>
                  <div>
                    <file-upload
                      :media="'image'"
                      :accept="accepted"
                      label="upload"
                      :src="docLink"
                      :refName="'upload7098'"
                      :role="'patient'"
                      :multiple="false"
                      :module="'referred'"
                      :drop="true"
                      @uploaded="fileUploaded"
                      @showImage="showImage"
                      :uploadFileToServer="true"
                      :uploadedImg="uploadedImg"
                      @removeImage="deleteImg"
                    ></file-upload>
                  </div>
                  <!-- <span class="text-danger">{{ imageError }}</span> -->
                </v-col>
              </v-row>
              <!-- <v-row>
                
              </v-row>-->

              <div class="text-right mt-5">
                <v-btn color="error" class="mr-4" @click="closeModal()">Cancel</v-btn>
                <v-btn :disabled="!valid" color="success" @click="submitForm()">Submit</v-btn>
              </div>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <image-preview
      @close="closeImageModal"
      v-if="openImageModal"
      :openImageModal="openImageModal"
      :source="fileUrl"
      :fileArcheType="fileArcheType"
    ></image-preview>
  </div>
</template>

<script>
import config from "@/config.js";
const loader = () => import("@/components/loader.vue");
import { pickSvg } from "@/views/SVG";
import FileUpload from "@/components/FileUpload.vue";
const imagePreview = () => import("@/components/modals/imagePreview.vue");

export default {
  components: {
    ...pickSvg("pdfSVG", "sendSVG", "attachmentSVG"),
    loader,
    FileUpload,
    "image-preview": imagePreview
  },
  props: ["openCreateForm", "modalType", "MarketingAgentData"],
  computed: {
    isReferralCodeEditable: function() {
      // `this` points to the vm instance
      return this.modalType.toLowerCase() === "edit";
    }
  },
  data() {
    return {
      accepted: "image/png,image/jpg,image/jpeg",
      docLink: null,
      showLoader: false,
      uploadedImg: [],
      uploadedImgFullUrl: [],
      accepted: "image/png,image/jpg,image/jpeg,image/pdf,application/pdf",
      valid: true,
      contactPersonRules: [
        v => /^[^-\s][a-zA-Z0-9_\s-]+$/.test(v) || "Contact Person is required"
      ],
      contactNumberRules: [
        v => !!v || "Mobile no is required",
        v => !isNaN(v) || "Please enter valid mobile number",
        v => v !== "." || "Please enter valid mobile number",
        v => (v && v.length === 10) || "Please enter valid mobile number"
      ],
      formData: {
        nameOfCompany: "",
        contactEmail: "",
        contactPerson: "",
        contactNumber: "",
        typeOfAgreement: ""
      },
      openImageModal: false,
      fileUrl: "",
      fileArcheType: ""
    };
  },

  created() {
    if (this.modalType === "Edit") {
      this.formData.nameOfCompany = this.MarketingAgentData.company_name;
      this.formData.contactPerson = this.MarketingAgentData.contact_person;
      this.formData.contactNumber = this.MarketingAgentData.contact_number;
      this.formData.contactEmail = this.MarketingAgentData.contact_email;
      this.formData.allocateReferralCode = this.MarketingAgentData.referral_code;
      this.formData.typeOfAgreement = this.MarketingAgentData.type_of_agreement;
      this.uploadedImgFullUrl = this.MarketingAgentData.file_attachment_links;
      if (this.MarketingAgentData.file_attachment_links) {
        this.uploadedImg = this.MarketingAgentData.file_attachment_links.map(
          el => {
            return el.split("/").pop();
          }
        );
      }
    } else {
      this.getReferralCode();
    }
  },

  methods: {
    closeImageModal() {
      this.openImageModal = false;
    },
    openModal(fileUrl, fileArcheType) {
      this.fileUrl = fileUrl;
      this.fileArcheType = fileArcheType;
      this.openImageModal = true;
    },
    showImage(img) {
      const imageUrl = this.uploadedImgFullUrl.find(el => el.includes(img));
      this.openModal(imageUrl, "image");
    },

    getReferralCode() {
      this.showLoader = true;
      let url = `${config.BASE_URL}api/v2/admin/generate-referral-code`;
      this.$http.get(url).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          this.formData.allocateReferralCode = response.body.data.referral_code;
        }
      });
    },

    // uploade image method
    fileUploaded(files, uploaded, name) {
      this.showLoader = true;
      if (uploaded) {
        this.uploadedImgFullUrl = files;
        this.uploadedImg = files.map(el => {
          return el.split("/").pop();
        });

        this.showLoader = false;
      }
    },

    // delete iamge method
    deleteImg() {
      this.uploadedImg = [];
      this.uploadedImgFullUrl = [];
    },

    // close modal event
    closeModal() {
      this.uploadedImg = [];
      this.uploadedImgFullUrl = [];
      this.$emit("close");
      this.$refs.createForm.reset();
    },

    // submit event for edit and create functionality
    submitForm() {
      if (this.$refs.createForm.validate()) {
        this.showLoader = true;
        let obj = {
          company_name: this.formData.nameOfCompany,
          contact_person: this.formData.contactPerson,
          contact_number: this.formData.contactNumber,
          type_of_agreement: this.formData.typeOfAgreement,
          referral_code: this.formData.allocateReferralCode,
          file_attachment_links: this.uploadedImgFullUrl,
          contact_email: this.formData.contactEmail
        };

        if (this.modalType !== "Edit") {
          let url = `${config.BASE_URL}api/v2/admin/referral-marketing-agents`;
          this.$http.post(url, obj).then(response => {
            if (response.body.status) {
              this.showLoader = false;
              this.$refs.createForm.reset();
              this.uploadedImg = [];
              this.uploadedImgFullUrl = [];
              this.$emit("close");
              this.$emit("getApiCall");
            } else {
              this.showLoader = false;
            }
          });
        } else {
          let url = `${config.BASE_URL}api/v2/admin/referral-marketing-agents/${this.MarketingAgentData._id}/edit`;
          this.$http.put(url, obj).then(response => {
            if (response.body.status) {
              this.showLoader = false;
              this.$refs.createForm.reset();
              this.uploadedImg = [];
              this.uploadedImgFullUrl = [];
              this.$emit("close");
              this.$emit("getApiCall");
            } else {
              this.showLoader = false;
            }
          });
        }
      }
    }
  }
};
</script>
